
<div *ngIf="isConsentAccepted">
    <form class="hidden-form" [formGroup]="yodleeForm" id="yodleeForm" method="POST" target="yoodleFinApp" (ngSubmit)="submitForm()" #form>
        <input type="text" name="app" id="app" formControlName="app" [style.visibility]="'hidden'"/>
        <input type="text" name="rsession" id="resession" formControlName="rsession" [style.visibility]="'hidden'"/>
        <input type="text" name="token" id="token" formControlName="token" [style.visibility]="'hidden'"/>
        <input type="text" name="redirectReq" id="redirectReq" formControlName="redirectReq" [style.visibility]="'hidden'"/>
        <input type="text" name="extraParams" id="extraParams" formControlName="extraParams" [style.visibility]="'hidden'"/>
        <button type="submit" [style.visibility]="'hidden'"></button>
    </form>

    <div class="iframe-parent-wrapper">
        <iframe #iframe id="yoodleFinApp" name="yoodleFinApp" frameborder="0" cellspacing="0" [ngClass]="{
            'finapp-iframe': !isBudgetTool,
            'finapp-budget-iframe': isBudgetTool
        }"
        ></iframe>
    </div>
</div>

<div *ngIf="!isConsentAccepted" [ngClass]="{hide: hideConsent}">
    <div class="yodlee-consent-content" [innerHTML]="bodyContent">
    </div>
    <div class="text-center yodlee-consent-ctas">
        <button id="accept-tnc-btn" class="btn btn-primary" (click)="acceptConsent()">Accept</button>
        <button id="decline-tnc-btn" class="btn btn-default" style="margin-left:5px" (click)="close()">Decline</button>
    </div>
</div>
